<template>
  <div class="resource_subject_add_wrap">
    <div class="header">
      <el-button size="medium" @click="goBack">返回</el-button>
      <el-button size="medium" type="primary" @click="saveSuite">保存</el-button>
    </div>
    <div class="resource_subject_box" :style="`height: ${windowHeight - 170}px;`">
      <div class="resource_subject_content">
        <el-form ref="form" label-width="140px" class="demo-ruleForm">
          <el-form-item label="封面" prop="bookPic">
            <uploader pathPrefix="resourceSubject" :extList="['png', 'jpg', 'jpeg']" showResult="image" showMode="cover" v-model="bookPic" :multiple="true"></uploader>
          </el-form-item>
          <el-form-item label="备注" prop="remark">
            <el-input type="textarea" :rows="5" placeholder="请输入内容" v-model="remark">
            </el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
  import windowResize from '@/mixins/windowResize'
  import Uploader from "@/components/Uploader/WebUploader";
  import {getGradeAtlasDetailInfoById, editGradeAtlas} from '@/api/resourceMap'

  export default {
    name: "resourceSubjectEdit",
    components: {Uploader},
    data() {
      return {
        atlasId: this.$route.query.atlasId,
        id: this.$route.query.id,
        bookPic: [],
        remark: '',
        name: ''
      }
    },
    mixins: [windowResize],
    created() {
      this.getGradeAtlasDetailInfoById();
    },
    methods: {
      goBack() {
        this.$router.go(-1);
      },
      getGradeAtlasDetailInfoById() {
        getGradeAtlasDetailInfoById({gradeAtlasId: this.id}).then(data => {
          this.remark = data.remark;
          this.name = data.name;
          if (data.imgUrl) {
            this.bookPic = [{
              fileUrl: data.imgUrl
            }]
          }
        })
      },
      saveSuite() {
        new Promise(resolve => {
          let query = {
            id: this.id,
            imgUrl: this.bookPic.length ? this.bookPic[0].fileUrl : '',
            remark: this.remark,
            name: this.name,
          };
          editGradeAtlas(query).then(resolve)
        }).then(() => {
          this.$message.success(`编辑成功`);
          window.setTimeout(() => {
            this.goBack();
          }, 500);
        });
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import './../../../styles/mixin';

  .resource_subject_add_wrap {
    padding: 12px;

    .header {
      padding-bottom: 10px;
      border-bottom: 1px solid #eee;
    }

    .resource_subject_box {
      @include scrollBar;

      .resource_subject_content {
        width: 810px;
        margin: 0 auto;
        padding-top: 20px;

      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/study/resourceMap/resourceSubjectEdit.vue